import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Form, Input, Typography } from 'antd'

const inlineLayout = {
  labelCol: { xs: { span: 24 }, lg: { span: 8 } },
  wrapperCol: { xs: { span: 24 }, lg: { span: 12 } },
}

const bitcoinLabel = (
  <Typography.Text style={{ fontSize: '18px' }}>
    <span style={{ color: '#d60202' }}>*</span>4. Nos informe a sua carteira
    bitcoin:
  </Typography.Text>
)

export const Bitcoin = ({ handleChange, answers }) => {
  return (
    <Fragment>
      <Typography.Text style={{ fontSize: '18px' }}>
        ATENÇÃO: Em hipótese nenhuma dê a carteira de um terceiro para depósito.
        É impossível cancelar esta transação depois de feita, portanto, tenha
        muito cuidado para quem vai enviar o dinheiro. Depois de enviado, não
        poderemos reembolsar o pagamento.
      </Typography.Text>
      <Form.Item name='bitcoinWallet' label={bitcoinLabel} {...inlineLayout}>
        <Input
          type='text'
          name='bitcoinWallet'
          value={answers?.bitcoinWallet}
          onChange={handleChange('bitcoinWallet')}
          required
        />
      </Form.Item>
    </Fragment>
  )
}

Bitcoin.propTypes = {
  handleChange: PropTypes.func,
  answers: PropTypes.any,
}
